import {
  Button,
  Container,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FirebaseError } from "firebase/app";
import { useNavigate } from "react-router-dom";
import { PASSWORD_REGEXP_PATTERN_1 } from "../common/constants";
import Loading from "../components/common/Loading";
import { auth } from "../firebase";
import { EmailAuthProvider, updatePassword } from "firebase/auth";
import { useTranslation } from "react-i18next";

const ChangePasswordCard = styled("div")({
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
});

const ChangePassword = () => {
  const [inputCurrentPw, setInputCurrentPw] = useState("");
  const [inputUserPw, setInputUserPw] = useState("");
  const [inputUserConfirmPw, setInputUserConfirmPw] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const { t: tCommon } = useTranslation("common");
  const { t: tError } = useTranslation("errors");

  const handleRegister = async () => {
    setIsProcessing(true);
    try {
      const user = auth.currentUser;
      console.log("--s0200--", user);
      console.log("--s0201--", user?.providerId);
      console.log("--s0202--", user?.providerData);
      const providerId = user ? user.providerData[0].providerId : "";
      if (!user) {
        throw new FirebaseError("auth/user-not-found", "ログイン前ユーザ");
      }
      if (providerId !== "password") {
        throw new FirebaseError("auth/not-support", "emailユーザのみ可能");
      }
      if (
        !inputCurrentPw ||
        !(inputCurrentPw.length >= 8 && inputCurrentPw.length <= 16)
      ) {
        throw new Error("入力長さを確認下さい（8~16桁)。");
      }
      if (
        !inputUserPw ||
        !(inputUserPw.length >= 8 && inputUserPw.length <= 16)
      ) {
        throw new Error("入力長さを確認下さい（8~16桁)。");
      }
      if (!inputUserPw || !PASSWORD_REGEXP_PATTERN_1.test(inputUserPw)) {
        throw new Error("確認用パスワードと一致しません。");
      }
      if (!inputUserPw || inputUserPw !== inputUserConfirmPw) {
        throw new Error("確認用パスワードと一致しません。");
      }

      if (
        user &&
        user?.providerData &&
        user.providerData[0].providerId == "password" &&
        user.email
      ) {
        // 現在パスワードを更新
        const credential = EmailAuthProvider.credential(
          user.email,
          inputCurrentPw,
        );

        // パスワード更新
        await updatePassword(user, inputUserPw);
      }

      alert(tCommon("messages.updatedPassword"));

      navigate("/");
    } catch (error: any) {
      let message = "";
      if (error instanceof FirebaseError) {
        message = error.message;
        console.error("ユーザ登録 error: ", error.code, error.message);
      } else {
        message = error?.message ? error.message : "System Error";
      }
      switch (error.code) {
        case "auth/user-not-found":
        case "auth/wrong-password":
        case "auth/invalid-credential":
          message = tCommon("auth.currentPassword");
          break;
      }
      alert(`${tError("error.unknown")}. ${message}]`);
      if (error.code === "auth/user-not-found") {
        navigate("/login");
      }
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <ChangePasswordCard>
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          label={tCommon("auth.currentPassword")}
          type="password"
          value={inputCurrentPw}
          onChange={(e) => setInputCurrentPw(e.target.value)}
        />
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          label={tCommon("auth.password")}
          type="password"
          value={inputUserPw}
          onChange={(e) => setInputUserPw(e.target.value)}
        />
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ display: "block", mt: 0.5, mb: 1, px: 0.5 }}
        >
          {tCommon("auth.ruleOfPass")}
        </Typography>
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          label={tCommon("auth.confirmPassword")}
          type="password"
          value={inputUserConfirmPw}
          onChange={(e) => setInputUserConfirmPw(e.target.value)}
        />
        <Button
          sx={{ marginTop: "20px" }}
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleRegister}
        >
          {tCommon("auth.changePassword")}
        </Button>
      </ChangePasswordCard>
      {isProcessing && (
        <Loading message={tCommon("messages.processing")} blurBackdrop={true} />
      )}
    </Container>
  );
};

export default ChangePassword;
